import { msg } from '@lingui/core/macro';

import { defineEnum } from '@/shared/patterns/define-enum';

// Status do lote e da operação (services/dimensa/DimensaSubmission.types.ts:1-14; rótulos em
// contexts/dimensa/dimensaSubmissionOptions.ts:7-14 e :110-115). O fio manda número (`statusValue`) ou nome.
// Arquivo leve: entra no filtro da rota.

/** As opções do filtro "Status", na ordem do legado (dimensaSubmissionOptions.ts:7-13). */
export const DIMENSA_STATUS = defineEnum(
  {
    '0': { label: msg`Pendente` },
    '4': { label: msg`Em processamento` },
    '1': { label: msg`Enviado` },
    '2': { label: msg`Rejeitado` },
    '3': { label: msg`Falha` },
  },
  { numeric: true, order: ['0', '4', '1', '2', '3'] },
);

/** A coluna Status: os mesmos rótulos e "Desconhecido" para o que não casa (dimensaSubmissionOptions.ts:57-60). */
export const DIMENSA_STATUS_COLUMN = defineEnum(
  {
    '0': { label: msg`Pendente` },
    '4': { label: msg`Em processamento` },
    '1': { label: msg`Enviado` },
    '2': { label: msg`Rejeitado` },
    '3': { label: msg`Falha` },
    unknown: { label: msg`Desconhecido` },
  },
  { numeric: true, order: ['0', '4', '1', '2', '3', 'unknown'] },
);

/** Status por operação (`DimensaSubmissionOperationStatus`): 3 é "Crítica", não "Falha". */
export const DIMENSA_OPERATION_STATUS = defineEnum(
  {
    '0': { label: msg`Pendente` },
    '1': { label: msg`Enviada` },
    '2': { label: msg`Rejeitada` },
    '3': { label: msg`Crítica` },
    unknown: { label: msg`Desconhecido` },
  },
  { numeric: true, order: ['0', '1', '2', '3', 'unknown'] },
);

const SUBMISSION_BY_NAME: Readonly<Record<string, string>> = { pending: '0', sent: '1', rejected: '2', failed: '3', processing: '4' };
const OPERATION_BY_NAME: Readonly<Record<string, string>> = { pending: '0', sent: '1', rejected: '2', critical: '3' };

function normalize(input: unknown, byName: Readonly<Record<string, string>>, known: readonly string[]): string | undefined {
  if (input === null || input === undefined) return undefined;
  if (typeof input === 'number') return known.includes(String(input)) ? String(input) : undefined;
  if (typeof input !== 'string') return undefined;
  const key = input.trim().toLowerCase();
  if (Object.hasOwn(byName, key)) return byName[key];
  const asNumber = Number(key);
  return !Number.isNaN(asNumber) && known.includes(String(asNumber)) ? String(asNumber) : undefined;
}

/** `normalizeDimensaStatus` (dimensaSubmissionOptions.ts:38-55): número, nome ou número em texto. */
export const normalizeSubmissionStatus = (input: unknown) => normalize(input, SUBMISSION_BY_NAME, ['0', '1', '2', '3', '4']);

/** `normalizeDimensaOperationStatus` (dimensaSubmissionOptions.ts:127-147). */
export const normalizeOperationStatus = (input: unknown) => normalize(input, OPERATION_BY_NAME, ['0', '1', '2', '3']);

/**
 * Sub-lote de pendentes: `LotNumber` com LETRA MAIÚSCULA no fim ("9A", "9B"); o hex minúsculo do número de
 * cessão e "9-1" não casam (dimensaSubmissionOptions.ts:85-86).
 */
export const isSubLot = (lotNumber: string | null | undefined): boolean => !!lotNumber && /[A-Z]$/.test(lotNumber.trim());

/** Reenviável: Rejeitado/Falha, ou Pendente com lote de letra (dimensaSubmissionOptions.ts:70-105). */
export function canResendRow(row: { readonly statusKey: string; readonly lotNumber?: string | null | undefined }): boolean {
  return row.statusKey === '2' || row.statusKey === '3' || (row.statusKey === '0' && isSubLot(row.lotNumber));
}
